import { useDataIsSubmitting, useDataValue, useDataSubmit } from 'Simple/Data'

export function useDisabled(props) {
  let isSubmitting = useDataIsSubmitting({
    viewPath: props.viewPath,
    context: 'tab',
  })

  let board_id = useDataValue({
    viewPath: props.viewPath,
    path: 'board_id',
    context: 'selected',
  })

  let stage_id = useDataValue({
    viewPath: props.viewPath,
    path: 'stage_id',
    context: 'selected',
  })

  return isSubmitting || !board_id || !stage_id
}

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let selectedSubmit = useDataSubmit({
    context: 'selected',
    viewPath: props.viewPath,
  })

  let board_id = useDataValue({
    viewPath: props.viewPath,
    path: 'board_id',
    context: 'selected',
  })

  let stage_id = useDataValue({
    viewPath: props.viewPath,
    path: 'stage_id',
    context: 'selected',
  })

  let tasks = useDataValue({
    context: 'selected',
    path: 'tasks',
    viewPath: props.viewPath,
  })

  return async function onClick() {
    await submit({
      type: 'move_tasks',
      ids: tasks.map(task => task.id),
      board_id,
      stage_id,
    })
    selectedSubmit({ type: 'close' })
  }
}
